import { CcfBox, CcfTypography } from '@nice-ccf/ui-controls';
import styles from './chat-interaction-flow.module.scss';
import { useSelector } from 'react-redux';
import { activeContactSelector } from 'libs/react/ui-components/src/lib/ccf-inbox/ccf-inbox.slice';

/* eslint-disable-next-line */
export interface ChatInteractionFlowProps {
  interaction?: any;
}

/**
 * ChatInteractionFlow - used to display Chat/SMS Conversation in Interaction Tab Details View
 * @param props - -ChatInteractionFlowProps
 * @returns - appspace
 * @example - `<ChatInteractionFlow />`
 */
export function ChatInteractionFlow(props: ChatInteractionFlowProps) {
  const { interaction } = props;
  const activeContact = useSelector(activeContactSelector);
  const customerName = `${activeContact?.customer.firstName} ${activeContact?.customer.lastName}`;
  const chatInteractionData = [
    {
      messageFrom: 'customer',
      customerName: customerName,
      message: "Help! I can't find my lost bags!!!",
      timeStamp: 'Today 8:23am',
    },
    {
      messageFrom: 'agent',
      agentName: interaction.agentName,
      message:
        'Let me send you a new link to where you can find your bags. give me a second',
      timeStamp: 'Today 8:24am',
    },
    {
      messageFrom: 'agent',
      agentName: interaction.agentName,
      message: 'Did this take care of it for you',
      timeStamp: 'Today 8:28am',
    },
    {
      messageFrom: 'customer',
      customerName: customerName,
      message:
        'I called yesterday and spoke to another agent and just wanted to follow up . They were supposed to look into my lost bags.',
      timeStamp: 'Today 8:35am',
    },
    {
      messageFrom: 'agent',
      agentName: interaction.agentName,
      message:
        'Thank you for letting me know, I will look into this issue right now and advise on the status.',
      timeStamp: 'Today 8:40am',
    },
    {
      messageFrom: 'customer',
      customerName: customerName,
      message: "I still can't figure out the status...",
      timeStamp: 'now',
    },
  ];
  return (
    <CcfBox className={styles.chatInteractionContainer}>
      <CcfBox className={styles.chatInteractionHeader} >
        <CcfTypography translationKey={'startOfConversation'}></CcfTypography>
      </CcfBox>
      <CcfBox className={styles.chatInteractionContent}>
        {chatInteractionData.map((chat, index) => (
          <CcfBox
            key={index}
            className={
              chat.messageFrom === 'agent'
                ? styles.chatInteractionContentAgent
                : styles.chatInteractionContentCustomer
            }
          >
            <CcfTypography className={styles.name}>
              {chat.messageFrom === 'agent'
                ? chat.agentName
                : chat.customerName}
            </CcfTypography>
            <CcfBox className={styles.messageblock}>
              <CcfTypography className={styles.message}>
                {chat.message}
              </CcfTypography>
            </CcfBox>
            <CcfTypography className={styles.timeStamp}>
              {chat.timeStamp}
            </CcfTypography>
          </CcfBox>
        ))}
      </CcfBox>
    </CcfBox>
  );
}

export default ChatInteractionFlow;
